// import React, { useEffect, useState } from "react";
// import createInstance from "../../../api/axiosinstance";

import { Dashboard } from "@mui/icons-material"

// const MockDash = ({ skillCount }) => {
//   const [users, SetUsers] = useState([]);
//   const [skillsCount, SetSkillCount] = useState();
//   const [roles, setRoles] = useState([]);
//   const [orgList, setOrgList] = useState([]);
//   const [jobsBySkills, setJobsBySkills] = useState([]);
//   const aiDisha = createInstance("DISHA");

//   useEffect(() => {
//     Dashboard();
//     fetchUsers();
//     fetchSkillsCount();
//     fetchRoleCount();
//     getOrgList();
//   }, []);
//   const Dashboard = async () => {
//     try {
//       const response = await aiDisha.get("/Admin_Dashboard_values/");
//       console.log("dashboard", response.data);
//       setJobsBySkills(response.data.Active_Jobs_by_Skills);
//     } catch (error) {
//       console.log("error", error);
//     }
//   };
//   const fetchUsers = async () => {
//     try {
//       const response = await aiDisha.get("/get-all-users");
//       console.log("all userz", response);
//       SetUsers(response.data.All_users);
//       console.log("all userz", response.data.All_users);
//     } catch (error) {
//       console.log(error);
//     }
//   };
//   const fetchSkillsCount = async () => {
//     try {
//       const response = await aiDisha.get("/skills-show/active");
//       if (response.data) {
//         SetSkillCount(response.data.count || 0);
//         console.log("skills", response);
//       }
//     } catch (error) {
//       console.error("Error fetching skills for dropdown:", error.message);
//     }
//   };
//   const fetchRoleCount = async () => {
//     try {
//       const response = await aiDisha.get("/get-all-active-admin-roles/");
//       if (response.data) {
//         setRoles(response.data);
//         console.log("Roles", response);
//       }
//     } catch (error) {
//       console.error("Error fetching roles:", error.message);
//     }
//   };
//   const getOrgList = async () => {
//     await aiDisha
//       .get("/get-all-active-organizations?status=Active")
//       .then((response) => {
//         setOrgList(response.data);
//         console.log("ORG LIST : ", response.data);
//       })
//       .catch((error) => {
//         console.log("Error fetching active organizations", error);
//       });
//   };
//   return (
//     <div style={{ boxShadow: "-16px -9px 19px -8px rgba(0,0,0,0.75)" }}>
//       <svg
//         width="100%"
//         height="100%"
//         viewBox="0 0 1200 800"
//         xmlns="http://www.w3.org/2000/svg"
//       >
//         <defs>
//           <linearGradient id="d" x1="0" y1="0" x2="0" y2="1">
//             <stop offset="5%" stop-color="#4d79ff" stop-opacity=".5" />
//             <stop offset="95%" stop-color="#6989e0" stop-opacity=".5" />
//           </linearGradient>
//           <filter id="b">
//             <feGaussianBlur in="SourceGraphic" stdDeviation="5" result="blur" />
//             <feColorMatrix
//               in="blur"
//               values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 0.2 -0.1"
//               result="glass"
//             />
//           </filter>
//           <filter id="c" width="150%" height="150%">
//             <feGaussianBlur stdDeviation="4" result="blur" />
//             <feComposite in="SourceGraphic" in2="blur" />
//           </filter>
//         </defs>
//         <rect width="100%" height="100%" fill="#ffffff" />

//         <g transform="translate(60 50)">
//           <rect
//             width="170"
//             height="120"
//             rx="12"
//             fill="rgba(244, 249, 233, 0.8)"
//             filter="url(#b)"
//             stroke="#4d79ff"
//             stroke-opacity=".3"
//           />
//           <circle cx="30" cy="30" r="30" fill="#4d79ff" filter="url(#c)" />
//           <text
//             x="30"
//             y="35"
//             font-family="Arial"
//             font-size="30"
//             fill="#fff"
//             text-anchor="middle"
//           >
//             👥
//           </text>
//           <text x="70" y="20" font-family="Arial" font-size="16" fill="#000000">
//             Total Users
//           </text>
//           <text x="70" y="50" font-family="Arial" font-size="24" fill="#000000">
//             {users.length}
//           </text>
//           <text x="70" y="75" font-family="Arial" font-size="10" fill="#19a651">
//             ↑ 12%
//           </text>
//           <rect
//             x="190"
//             width="170"
//             height="120"
//             rx="12"
//             fill="rgba(244, 249, 233, 0.8)"
//             filter="url(#b)"
//             stroke="#ff4757"
//             stroke-opacity=".3"
//           />
//           <circle cx="250" cy="25" r="30" fill="#ff4757" filter="url(#c)" />
//           <text
//             x="250"
//             y="35"
//             font-family="Arial"
//             font-size="30"
//             fill="#fff"
//             text-anchor="middle"
//           >
//             📊
//           </text>
//           <text
//             x="300"
//             y="20"
//             font-family="Arial"
//             font-size="16"
//             fill="#000000"
//           >
//             Active Skills
//           </text>
//           <text
//             x="300"
//             y="50"
//             font-family="Arial"
//             font-size="24"
//             fill="#000000"
//           >
//             {skillsCount || 87}
//           </text>
//           <text
//             x="300"
//             y="75"
//             font-family="Arial"
//             font-size="10"
//             fill="#19a651"
//           >
//             ↑ 5
//           </text>
//           <rect
//             x="380"
//             width="170"
//             height="120"
//             rx="12"
//             fill="rgba(244, 249, 233, 0.8)"
//             filter="url(#b)"
//             stroke="#4dff88"
//             stroke-opacity=".3"
//           />
//           <circle cx="500" cy="25" r="30" fill="#4dff88" filter="url(#c)" />
//           <text
//             x="500"
//             y="35"
//             font-family="Arial"
//             font-size="30"
//             fill="#fff"
//             text-anchor="middle"
//           >
//             👔
//           </text>
//           <text
//             x="550"
//             y="20"
//             font-family="Arial"
//             font-size="16"
//             fill="#000000"
//           >
//             Active Roles
//           </text>
//           <text
//             x="550"
//             y="50"
//             font-family="Arial"
//             font-size="24"
//             fill="#000000"
//           >
//             {roles.length}
//           </text>
//           <text
//             x="550"
//             y="75"
//             font-family="Arial"
//             font-size="10"
//             fill="#ff4757"
//           >
//             ↓ 2
//           </text>
//           <rect
//             x="570"
//             width="170"
//             height="120"
//             rx="12"
//             fill="rgba(244, 249, 233, 0.8)"
//             filter="url(#b)"
//             stroke="#ffd166"
//             stroke-opacity=".3"
//           />
//           <circle cx="730" cy="25" r="30" fill="#ffd166" filter="url(#c)" />
//           <text
//             x="730"
//             y="35"
//             font-family="Arial"
//             font-size="30"
//             fill="#fff"
//             text-anchor="middle"
//           >
//             🏢
//           </text>
//           <text
//             x="780"
//             y="20"
//             font-family="Arial"
//             font-size="16"
//             fill="#000000"
//           >
//             Organizations
//           </text>
//           <text
//             x="780"
//             y="50"
//             font-family="Arial"
//             font-size="24"
//             fill="#000000"
//           >
//             {orgList.length}
//           </text>
//           <text
//             x="780"
//             y="75"
//             font-family="Arial"
//             font-size="10"
//             fill="#19a651"
//           >
//             ↑ 3
//           </text>
//         </g>
//         <g transform="translate(60 220)">
//           <rect
//             width="400"
//             height="250"
//             rx="12"
//             fill="rgba(244, 249, 233, 0.8)"
//             filter="url(#b)"
//           />
//           <text x="30" y="30" font-family="Arial" font-size="20" fill="#000000">
//             Active Jobs by Skills
//           </text>
//           {jobsBySkills.map((item, index) => (
//             <React.Fragment key={index}>
//               <rect
//                 x={40 + index * 70}
//                 y={200 - item.job_count * 15}
//                 width="60"
//                 height={item.job_count * 15}
//                 fill="url(#d)"
//                 rx="4"
//               />
//               <text
//                 x={70 + index * 70}
//                 y="245"
//                 font-family="Arial"
//                 font-size="13"
//                 fill="#000000"
//                 text-anchor="middle"
//               >
//                 {item.skill}
//               </text>
//             </React.Fragment>
//           ))}
//           <rect
//             x="380"
//             width="360"
//             height="220"
//             rx="12"
//             fill="rgba(244, 249, 233, 0.8)"
//             filter="url(#b)"
//           />
//           <text
//             x="500"
//             y="30"
//             font-family="Arial"
//             font-size="20"
//             fill="#000000"
//           >
//             Top Required Skills
//           </text>
//           <circle cx="610" cy="120" r="60" fill="#4d79ff" fill-opacity=".6" />
//           <path
//             d="M610 60a60 60 0 0 1 30 60h-30Z"
//             fill="#4dff88"
//             fill-opacity=".6"
//           />
//           <path
//             d="M610 60a60 60 0 0 0-30 60h30Z"
//             fill="#ff4757"
//             fill-opacity=".6"
//           />
//           <text
//             x="490"
//             y="160"
//             font-family="Arial"
//             font-size="13"
//             fill="#000000"
//           >
//             Linux: 38%
//           </text>
//           <text
//             x="490"
//             y="180"
//             font-family="Arial"
//             font-size="13"
//             fill="#000000"
//           >
//             AWS: 32%
//           </text>
//           <text
//             x="490"
//             y="200"
//             font-family="Arial"
//             font-size="13"
//             fill="#000000"
//           >
//             Python: 30%
//           </text>
//           <rect
//             width="720"
//             height="120"
//             rx="12"
//             fill="rgba(244, 249, 233, 0.8)"
//             filter="url(#b)"
//           />
//           <text
//             x="750"
//             y="30"
//             font-family="Arial"
//             font-size="20"
//             fill="#000000"
//           >
//             Candidate Pipeline
//           </text>
//           <rect x="750" y="180" width="60" height="40" fill="url(#d)" rx="4" />
//           <rect x="850" y="160" width="60" height="60" fill="url(#d)" rx="4" />
//           <rect x="950" y="140" width="60" height="80" fill="url(#d)" rx="4" />
//           <rect
//             x="1050"
//             y="120"
//             width="60"
//             height="100"
//             fill="url(#d)"
//             rx="4"
//           />
//           <text
//             x="790"
//             y="245"
//             font-family="Arial"
//             font-size="11"
//             fill="#000000"
//             text-anchor="middle"
//           >
//             Screening (120)
//           </text>
//           <text
//             x="890"
//             y="245"
//             font-family="Arial"
//             font-size="11"
//             fill="#000000"
//             text-anchor="middle"
//           >
//             Technical (80)
//           </text>
//           <text
//             x="990"
//             y="245"
//             font-family="Arial"
//             font-size="11"
//             fill="#000000"
//             text-anchor="middle"
//           >
//             Final (30)
//           </text>
//           <text
//             x="1080"
//             y="245"
//             font-family="Arial"
//             font-size="11"
//             fill="#000000"
//             text-anchor="middle"
//           >
//             Hired (10)
//           </text>
//         </g>
//       </svg>
//     </div>
//   );
// };

// export default MockDash;






















// import React, { useEffect, useState } from "react";
// import {
//   Box,
//   Grid,
//   Card,
//   CardContent,
//   Typography,
//   Chip,
//   Stack,
//   Alert,
//   Skeleton,
//   Divider,
//   useTheme,
// } from "@mui/material";
// import {
//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   Tooltip,
//   CartesianGrid,
//   ResponsiveContainer,
// } from "recharts";
// import createInstance from "../../../api/axiosinstance";

// const MockDash = () => {
//   const theme = useTheme();
//   const aiDisha = createInstance("DISHA");

//   const [data, setData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");

//   useEffect(() => {
//     const fetchDashboard = async () => {
//       try {
//         setLoading(true);
//         const response = await aiDisha.get("/Admin_Dashboard_values/");
//         setData(response.data);
//       } catch (err) {
//         console.error("Error fetching dashboard values:", err);
//         setError("Unable to load dashboard data at the moment.");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchDashboard();
//   }, []);

//   const metrics = [
//     {
//       label: "Total Users",
//       key: "total_active_users",
//       value: data?.total_active_users ?? 0,
//       trend: "+12%",
//       trendType: "up",
//     },
//     {
//       label: "Active Skills",
//       key: "total_active_skills",
//       value: data?.total_active_skills ?? 0,
//       trend: "+5",
//       trendType: "up",
//     },
//     {
//       label: "Active Roles",
//       key: "total_active_roles",
//       value: data?.total_active_roles ?? 0,
//       trend: "-2",
//       trendType: "down",
//     },
//     {
//       label: "Organizations",
//       key: "total_active_org",
//       value: data?.total_active_org ?? 0,
//       trend: "+3",
//       trendType: "up",
//     },
//   ];

//   const jobsBySkills = data?.Active_Jobs_by_Skills ?? [];

//   // Static candidate pipeline (until backend exposes it)
//   const candidatePipeline = [
//     { stage: "Screening", count: 120 },
//     { stage: "Technical", count: 80 },
//     { stage: "Final", count: 30 },
//     { stage: "Hired", count: 10 },
//   ];

//   const renderMetricSkeleton = () => (
//     <Grid container spacing={2} mb={3}>
//       {Array.from({ length: 4 }).map((_, idx) => (
//         <Grid item xs={12} sm={6} md={3} key={idx}>
//           <Card sx={{ borderRadius: 3 }}>
//             <CardContent>
//               <Skeleton variant="text" width={80} />
//               <Skeleton variant="text" width={60} sx={{ mt: 1 }} />
//               <Skeleton variant="rectangular" height={24} sx={{ mt: 2 }} />
//             </CardContent>
//           </Card>
//         </Grid>
//       ))}
//     </Grid>
//   );

//   const renderBottomSkeleton = () => (
//     <>
//       {/* Row 2 skeleton – Active Jobs by Skills full width */}
//       <Grid container spacing={2} mb={2}>
//         <Grid item xs={12}>
//           <Card sx={{ borderRadius: 3, height: 320 }}>
//             <CardContent>
//               <Skeleton variant="text" width={180} />
//               <Skeleton
//                 variant="rectangular"
//                 height={240}
//                 sx={{ mt: 2, borderRadius: 2 }}
//               />
//             </CardContent>
//           </Card>
//         </Grid>
//       </Grid>

//       {/* Row 3 skeleton – Skills snapshot & Candidate pipeline side by side */}
//       <Grid container spacing={2}>
//         <Grid item xs={12} md={6}>
//           <Card sx={{ borderRadius: 3, height: 260 }}>
//             <CardContent>
//               <Skeleton variant="text" width={150} />
//               <Skeleton
//                 variant="rectangular"
//                 height={190}
//                 sx={{ mt: 2, borderRadius: 2 }}
//               />
//             </CardContent>
//           </Card>
//         </Grid>
//         <Grid item xs={12} md={6}>
//           <Card sx={{ borderRadius: 3, height: 260 }}>
//             <CardContent>
//               <Skeleton variant="text" width={150} />
//               <Skeleton
//                 variant="rectangular"
//                 height={190}
//                 sx={{ mt: 2, borderRadius: 2 }}
//               />
//             </CardContent>
//           </Card>
//         </Grid>
//       </Grid>
//     </>
//   );

//   return (
//     <Box
//       sx={{
//         p: 3,
//         bgcolor: (theme) =>
//           theme.palette.mode === "light" ? "#f5f7fb" : "background.default",
//         minHeight: "100%",
//       }}
//     >
//       {/* Error state */}
//       {!loading && error && (
//         <Box mb={2}>
//           <Alert severity="error" variant="outlined">
//             {error}
//           </Alert>
//         </Box>
//       )}

//       {/* Row 1: Top metrics */}
//       {loading ? (
//         renderMetricSkeleton()
//       ) : (
//         <Grid container spacing={2} mb={3}>
//           {metrics.map((metric) => (
//             <Grid item xs={12} sm={6} md={3} key={metric.key}>
//               <Card
//                 sx={{
//                   borderRadius: 3,
//                   boxShadow: 4,
//                   height: "100%",
//                 }}
//               >
//                 <CardContent>
//                   <Stack direction="row" justifyContent="space-between">
//                     <Typography
//                       variant="body2"
//                       color="text.primary"
//                       fontWeight={500}
//                     >
//                       {metric.label}
//                     </Typography>
//                     <Chip
//                       size="small"
//                       label={metric.trend}
//                       color={
//                         metric.trendType === "up"
//                           ? "success"
//                           : metric.trendType === "down"
//                           ? "error"
//                           : "default"
//                       }
//                       variant="soft"
//                       sx={{
//                         fontSize: 11,
//                         borderRadius: "999px",
//                       }}
//                     />
//                   </Stack>

//                   <Typography
//                     variant="h4"
//                     sx={{ mt: 1 }}
//                     fontWeight={700}
//                     color="text.primary"
//                   >
//                     {metric.value}
//                   </Typography>
//                 </CardContent>
//               </Card>
//             </Grid>
//           ))}
//         </Grid>
//       )}

//       {/* Row 2 + Row 3 */}
//       {loading ? (
//         renderBottomSkeleton()
//       ) : (
//         <>
//           {/* Row 2: Active Jobs by Skills (full width) */}
//           <Grid container spacing={2} mb={2} >
//             <Grid item xs={12}>
//               <Card
//                 sx={{
//                   borderRadius: 3,
//                   boxShadow: 4,
//                   height: 320,
//                   display: "flex",
//                   flexDirection: "column",
//                 }}
//               >
//                 <CardContent
//                   sx={{ flex: 1, display: "flex", flexDirection: "column" }}
//                 >
//                   <Stack
//                     direction="row"
//                     justifyContent="space-between"
//                     alignItems="center"
//                     mb={2}
//                   >
//                     <Box>
//                       <Typography
//                         variant="subtitle1"
//                         fontWeight={600}
//                         sx={{ color: "black" }}
//                       >
//                         Active Jobs by Skills
//                       </Typography>
//                       <Typography variant="caption" color="text.secondary">
//                         Jobs distribution across key skill sets
//                       </Typography>
//                     </Box>
//                   </Stack>

//                   {jobsBySkills.length === 0 ? (
//                     <Box
//                       sx={{
//                         flex: 1,
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                       }}
//                     >
//                       <Typography variant="body2" color="text.secondary">
//                         No active jobs by skills yet.
//                       </Typography>
//                     </Box>
//                   ) : (
//                     <Box sx={{ flex: 1 }}>
//                       <ResponsiveContainer width="100%" height="100%">
//                         <BarChart
//                           data={jobsBySkills}
//                           margin={{ top: 8, right: 8, bottom: 24, left: 0 }}
//                         >
//                           <CartesianGrid
//                             strokeDasharray="3 3"
//                             vertical={false}
//                             stroke={
//                               theme.palette.mode === "light"
//                                 ? "#e5e7eb"
//                                 : "#374151"
//                             }
//                           />
//                           <XAxis
//                             dataKey="skill"
//                             tick={{ fontSize: 11 }}
//                             tickMargin={8}
//                             fill="#6366f1"
//                           />
//                           <YAxis
//                             allowDecimals={false}
//                             tick={{ fontSize: 11 }}
//                           />
//                           <Tooltip
//                             contentStyle={{
//                               fontSize: 12,
//                               borderRadius: 8,
//                             }}
//                           />
//                           <Bar
//                             dataKey="job_count"
//                             radius={[6, 6, 0, 0]}
//                             fill={theme.palette.primary.main}
//                           />
//                         </BarChart>
//                       </ResponsiveContainer>
//                     </Box>
//                   )}
//                 </CardContent>
//               </Card>
//             </Grid>
//           </Grid>

//           {/* Row 3: Skills Snapshot (left) & Candidate Pipeline (right) */}
//           <Grid container spacing={2}>
//             {/* Skills Snapshot */}
//             <Grid item xs={12} md={6}>
//               <Card
//                 sx={{
//                   borderRadius: 3,
//                   boxShadow: 4,
//                   height: 260,
//                 }}
//               >
//                 <CardContent sx={{ pb: 1.5, height: "100%" }}>
//                   <Stack
//                     direction="row"
//                     justifyContent="space-between"
//                     alignItems="center"
//                     mb={1}
//                   >
//                     <Typography variant="subtitle1" fontWeight={600} sx={{color:"black"}}>
//                       Skills Snapshot
//                     </Typography>
//                     <Typography variant="caption" color="text.secondary">
//                       Total skills: {data?.total_active_skills ?? 0}
//                     </Typography>
//                   </Stack>

//                   <Divider sx={{ mb: 1.5 }} />

//                   {jobsBySkills.length === 0 ? (
//                     <Typography variant="body2" color="text.secondary">
//                       Skills will surface here as jobs are created.
//                     </Typography>
//                   ) : (
//                     <Box
//                       sx={{
//                         maxHeight: 180,
//                         overflowY: "auto",
//                         pr: 1,
//                       }}
//                     >
//                       {jobsBySkills.map((item, idx) => (
//                         <Box
//                           key={item.skill}
//                           sx={{
//                             display: "flex",
//                             alignItems: "center",
//                             justifyContent: "space-between",
//                             py: 0.75,
//                             borderBottom:
//                               idx === jobsBySkills.length - 1
//                                 ? "none"
//                                 : `1px solid ${
//                                     theme.palette.mode === "light"
//                                       ? "#e5e7eb"
//                                       : "#374151"
//                                   }`,
                                  
//                           }}
//                         >
//                           <Typography
//                             variant="body2"
//                             fontWeight={500}
//                             color="text.primary"
//                           >
//                             {item.skill}
//                           </Typography>
//                           <Chip
//                             size="small"
//                             label={`${item.job_count} job${
//                               item.job_count > 1 ? "s" : ""
//                             }`}
//                             variant="outlined"
//                           />
//                         </Box>
//                       ))}
//                     </Box>
//                   )}
//                 </CardContent>
//               </Card>
//             </Grid>

//             {/* Candidate Pipeline */}
//             <Grid item xs={12} md={6}>
//               <Card
//                 sx={{
//                   borderRadius: 3,
//                   boxShadow: 4,
//                   height: 260,
//                 }}
//               >
//                 <CardContent>
//                   <Stack
//                     direction="row"
//                     justifyContent="space-between"
//                     alignItems="center"
//                     mb={1}
//                   >
//                     <Typography variant="subtitle1" fontWeight={600} sx={{color:"black"}}>
//                       Candidate Pipeline
//                     </Typography>
//                     <Typography variant="caption" color="text.secondary">
//                       Funnel view (static)
//                     </Typography>
//                   </Stack>

//                   <Divider sx={{ mb: 1.5 }} />

//                   <Stack spacing={1.25}>
//                     {candidatePipeline.map((stage) => {
//                       const max = candidatePipeline[0].count || 1;
//                       const widthPercent = (stage.count / max) * 100;
//                       return (
//                         <Box key={stage.stage}>
//                           <Stack
//                             direction="row"
//                             justifyContent="space-between"
//                             alignItems="center"
//                             mb={0.5}
//                           >
//                             <Typography
//                               variant="body2"
//                               color="text.primary"
//                               fontWeight={500}
//                             >
//                               {stage.stage}
//                             </Typography>
//                             <Typography
//                               variant="caption"
//                               color="text.secondary"
//                             >
//                               {stage.count} candidates
//                             </Typography>
//                           </Stack>
//                           <Box
//                             sx={{
//                               width: "100%",
//                               height: 8,
//                               borderRadius: 999,
//                               bgcolor:
//                                 theme.palette.mode === "light"
//                                   ? "#e5e7eb"
//                                   : "#111827",
//                               overflow: "hidden",
//                             }}
//                           >
//                             <Box
//                               sx={{
//                                 width: `${widthPercent}%`,
//                                 height: "100%",
//                                 bgcolor: theme.palette.primary.main,
//                               }}
//                             />
//                           </Box>
//                         </Box>
//                       );
//                     })}
//                   </Stack>
//                 </CardContent>
//               </Card>
//             </Grid>
//           </Grid>
//         </>
//       )}
//     </Box>
//   );
// };

// export default MockDash;












































































// #latest Dashboard


// import React, { useState,useEffect } from "react";
// import {
//   Box,
//   Grid,
//   Card,
//   CardContent,
//   Typography,
//   Chip,
//   LinearProgress,
//   Divider,
//   IconButton,
//   Tooltip,
//   Avatar,
//   Stack,
//   Paper,
//   useTheme,
// } from "@mui/material";
// import {
//   PeopleAlt,
//   Business,
//   WorkOutline,
//   EventNote,
//   CheckCircleOutline,
//   RecordVoiceOver,
//   LocationOn,
//   Map,
//   ApartmentOutlined,
//   LocationCityOutlined,
//   AutoAwesome,
//   CodeOutlined,
//   TrendingUp,
//   ManageAccountsOutlined,
//   GroupsOutlined,
//   VerifiedOutlined,
// } from "@mui/icons-material";
// import { useThemeMode } from "../../Themes/ThemeContextTemp";
// import createInstance from "../../../api/axiosinstance";

// // ─── Static API response ──────────────────────────────────────────────────────
// const API_DATA = {
//   metrics: {
//     total_organizations: 3,
//     active_organizations: 2,
//     total_users: 8,
//     active_users: 5,
//     total_staff: 2,
//     total_interviewers: 2,
//     third_party_interviewers: 4,
//     jobs_created: 3,
//     interviews_scheduled: 3,
//     interviews_completed: 3,
//   },
//   states: { total: 4, active: 3, inactive: 1, active_list: ["Karnataka", "Tamil Nadu", "Gujarat"] },
//   districts: {
//     total: 8,
//     active: 6,
//     inactive: 2,
//     active_list: ["Bengaluru Urban", "Mysuru", "Chennai", "Kamareddy", "Karimnagar", "Adilabad"],
//   },
//   cities: { total: 5, active: 3, inactive: 2, active_list: ["Bengaluru", "Chennai", "Warangal"] },
//   user_distribution: { null: 1, Admin: 2 },
//   interview_status: { Active: 2 },
//   Active_Jobs_by_Skills: [
//     { skill: "AI / ML", job_count: 5 },
//     { skill: "Python", job_count: 2 },
//     { skill: "Java", job_count: 2 },
//   ],
//   total_active_users: 2,
//   total_active_skills: 7,
//   total_active_roles: 2,
//   total_active_org: 2,
// };

// // ─── Helper Components ────────────────────────────────────────────────────────

// /** Top-level KPI card */
// function MetricCard({ label, value, sub, icon: Icon, accentColor, COLORS }) {
//   return (
//     <Card
//       elevation={0}
//       sx={{
//         background: COLORS.cardBg,
//         border: `1px solid ${COLORS.border}`,
//         borderRadius: 3,
//         height: "100%",
//         position: "relative",
//         overflow: "hidden",
//         transition: "transform 0.18s, box-shadow 0.18s",
//         "&:hover": { transform: "translateY(-2px)", boxShadow: `0 6px 24px ${accentColor}22` },
//       }}
//     >
//       {/* top accent stripe */}
//       <Box sx={{ height: 3, background: accentColor, borderRadius: "12px 12px 0 0" }} />
//       <CardContent sx={{ p: 2.2 }}>
//         <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
//           <Box>
//             <Typography sx={{ fontSize: 11, color: COLORS.card_txt_color, mb: 0.6, letterSpacing: 0.3 }}>
//               {label}
//             </Typography>
//             <Typography sx={{ fontSize: 28, fontWeight: 700, color: COLORS.text, lineHeight: 1 }}>
//               {value}
//             </Typography>
//             {sub && (
//               <Typography sx={{ fontSize: 11, color: COLORS.card_txt_color, mt: 0.8 }}>
//                 {sub}
//               </Typography>
//             )}
//           </Box>
//           <Avatar
//             sx={{
//               width: 38,
//               height: 38,
//               borderRadius: 2,
//               background: `${accentColor}18`,
//             }}
//           >
//             <Icon sx={{ fontSize: 18, color: accentColor }} />
//           </Avatar>
//         </Stack>
//       </CardContent>
//     </Card>
//   );
// }

// /** Horizontal progress bar row */
// function GeoRow({ label, active, total, color }) {
//   const pct = total > 0 ? Math.round((active / total) * 100) : 0;
//   return (
//     <Box sx={{ mb: 1.2 }}>
//       <Stack direction="row" justifyContent="space-between" mb={0.4}>
//         <Typography sx={{ fontSize: 12, fontWeight: 500 }}>{label}</Typography>
//         <Typography sx={{ fontSize: 11, opacity: 0.6 }}>
//           {active}/{total}
//         </Typography>
//       </Stack>
//       <LinearProgress
//         variant="determinate"
//         value={pct}
//         sx={{
//           height: 6,
//           borderRadius: 4,
//           backgroundColor: "rgba(128,128,128,0.12)",
//           "& .MuiLinearProgress-bar": { background: color, borderRadius: 4 },
//         }}
//       />
//     </Box>
//   );
// }

// /** Skill bar row */
// function SkillRow({ skill, count, max, COLORS }) {
//   const pct = max > 0 ? Math.round((count / max) * 100) : 0;
//   const colors = ["rgb(37,99,235)", "#7c3aed", "#0d9488"];
//   const idx = 0;
//   return (
//     <Box sx={{ mb: 1.6 }}>
//       <Stack direction="row" justifyContent="space-between" mb={0.5}>
//         <Typography sx={{ fontSize: 12, fontWeight: 500, color: COLORS.text }}>{skill}</Typography>
//         <Chip
//           label={`${count} job${count !== 1 ? "s" : ""}`}
//           size="small"
//           sx={{
//             height: 18,
//             fontSize: 10,
//             fontWeight: 600,
//             background: `${colors[idx % colors.length]}18`,
//             color: colors[idx % colors.length],
//           }}
//         />
//       </Stack>
//       <LinearProgress
//         variant="determinate"
//         value={pct}
//         sx={{
//           height: 8,
//           borderRadius: 4,
//           backgroundColor: "rgba(128,128,128,0.12)",
//           "& .MuiLinearProgress-bar": {
//             background: `linear-gradient(90deg, rgb(37,99,235), #7c3aed)`,
//             borderRadius: 4,
//           },
//         }}
//       />
//     </Box>
//   );
// }

// /** Section header */
// function SectionLabel({ children, COLORS }) {
//   return (
//     <Typography
//       sx={{
//         fontSize: 10,
//         fontWeight: 700,
//         letterSpacing: 1,
//         color: COLORS.card_txt_color,
//         textTransform: "uppercase",
//         mb: 1.2,
//         mt: 0.5,
//       }}
//     >
//       {children}
//     </Typography>
//   );
// }

// // ─── Main Dashboard ───────────────────────────────────────────────────────────

// export default function StrategicHireDashboard() {
//   const { COLORS, theme, toggleTheme } = useThemeMode();
//   const aiDisha = createInstance("DISHA");
//   const [data, setData] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
  
  
  
//   const mapDashboardData = (api) => {
//   return {
//     metrics: {
//       total_organizations: api.metrics?.total_organizations || 0,
//       active_organizations: api.metrics?.active_organizations || 0,
//       total_users: api.metrics?.total_users || 0,
//       active_users: api.metrics?.active_users || 0,
//       total_staff: api.metrics?.total_staff || 0,
//       total_interviewers: api.metrics?.total_interviewers || 0,
//       third_party_interviewers: api.metrics?.third_party_interviewers || 0,
//       jobs_created: api.metrics?.jobs_created || 0,
//       interviews_scheduled: api.metrics?.interviews_scheduled || 0,
//       interviews_completed: api.metrics?.interviews_completed || 0,
//     },

//     states: {
//       total: api.states?.total || 0,
//       active: api.states?.active || 0,
//       inactive: api.states?.inactive || 0,
//       active_list: api.states?.active_list || [],
//     },

//     districts: {
//       total: api.districts?.total || 0,
//       active: api.districts?.active || 0,
//       inactive: api.districts?.inactive || 0,
//       active_list: api.districts?.active_list || [],
//     },

//     cities: {
//       total: api.cities?.total || 0,
//       active: api.cities?.active || 0,
//       inactive: api.cities?.inactive || 0,
//       active_list: api.cities?.active_list || [],
//     },

//     user_distribution: api.user_distribution || { null: 0 },

//     interview_status: api.interview_status || { Active: 0 },

//     Active_Jobs_by_Skills:
//       api.Active_Jobs_by_Skills ||
//       api.jobs_by_skills ||   // fallback if backend uses different name
//       [],

//     total_active_users: api.total_active_users || 0,
//     total_active_skills: api.total_active_skills || 0,
//     total_active_roles: api.total_active_roles || 0,
//     total_active_org: api.total_active_org || 0,
//   };
// };

// useEffect(() => {
//   const fetchDashboard = async () => {
//     try {
//       setLoading(true);
//       const response = await aiDisha.get("/Admin_Dashboard_values/");

//       // 🔥 IMPORTANT: map response to your UI format
//       const mappedData = mapDashboardData(response.data);
//       console.log("Mapped Dashboard Data:", mappedData);
//       setData(mappedData);
//     } catch (err) {
//       console.error("Error fetching dashboard values:", err);
//       setError("Unable to load dashboard data at the moment.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   fetchDashboard();
// }, []);

//   const d = data || API_DATA ;  // fallback until API loads
//   const m = d.metrics;
//   const coverageScore = Math.round(
//     ((d.states.active / d.states.total +
//       d.districts.active / d.districts.total +
//       d.cities.active / d.cities.total) /
//       3) *
//       100
//   );

//   const maxSkillCount = Math.max(...d.Active_Jobs_by_Skills.map((s) => s.job_count));

//   const accent = theme === "dark" ? "#e6b450" : "rgb(37,99,235)";
//   const purple = "#7c3aed";
//   const teal = "#0d9488";
//   const green = "#16a34a";
//   const amber = "#d97706";

//   const kpiCards = [
//     {
//       label: "Total Users",
//       value: m.total_users,
//       sub: `${m.active_users} active · ${m.total_users - m.active_users} inactive`,
//       icon: PeopleAlt,
//       color: accent,
//     },
//     {
//       label: "Organizations",
//       value: m.total_organizations,
//       sub: `${m.active_organizations} active · ${m.total_organizations - m.active_organizations} inactive`,
//       icon: Business,
//       color: green,
//     },
//     {
//       label: "Jobs Created",
//       value: m.jobs_created,
//       sub: "Open positions",
//       icon: WorkOutline,
//       color: amber,
//     },
//     {
//       label: "Scheduled",
//       value: m.interviews_scheduled,
//       sub: `${d.interview_status.Active} currently active`,
//       icon: EventNote,
//       color: purple,
//     },
//     {
//       label: "Completed",
//       value: m.interviews_completed,
//       sub: "100% completion rate",
//       icon: CheckCircleOutline,
//       color: teal,
//     },
//     {
//       label: "Interviewers",
//       value: m.total_interviewers + m.third_party_interviewers,
//       sub: `${m.total_interviewers} staff · ${m.third_party_interviewers} 3rd-party`,
//       icon: RecordVoiceOver,
//       color: accent,
//     },
//   ];

//   const platformStats = [
//     { label: "Active Users", value: d.total_active_users, icon: GroupsOutlined, color: accent },
//     { label: "Active Skills", value: d.total_active_skills, icon: AutoAwesome, color: purple },
//     { label: "Active Roles", value: d.total_active_roles, icon: ManageAccountsOutlined, color: teal },
//     { label: "Active Orgs", value: d.total_active_org, icon: VerifiedOutlined, color: green },
//   ];

//   return (
//     <Box sx={{ background: COLORS.background, minHeight: "100vh", p: { xs: 2, md: 3 } }}>
//       {/* ── Top bar ── */}
//       <Stack direction="row" alignItems="center" justifyContent="space-between" mb={3}>
//         <Stack direction="row" alignItems="center" gap={1.5}>
//           <Avatar
//             sx={{
//               width: 40,
//               height: 40,
//               borderRadius: 2,
//               background: accent,
//             }}
//           >
//             <TrendingUp sx={{ fontSize: 20, color: "white" }} />
//           </Avatar>
//           <Box>
//             <Typography sx={{ fontSize: 16, fontWeight: 700, color: COLORS.text, lineHeight: 1.2 }}>
//               Strategic Hire
//             </Typography>
//             <Typography sx={{ fontSize: 11, color: COLORS.card_txt_color }}>
//               Admin Dashboard
//             </Typography>
//           </Box>
//         </Stack>
//         <Stack direction="row" alignItems="center" gap={1}>
//           <Chip
//             label="● Live"
//             size="small"
//             sx={{
//               fontSize: 11,
//               fontWeight: 600,
//               background: "rgba(22,163,74,0.12)",
//               color: "#16a34a",
//               height: 24,
//             }}
//           />
//           <Tooltip title={`Switch to ${theme === "dark" ? "light" : "dark"} theme`}>
//             <IconButton
//               onClick={toggleTheme}
//               size="small"
//               sx={{
//                 border: `1px solid ${COLORS.border}`,
//                 background: COLORS.cardBg,
//                 color: COLORS.text,
//                 borderRadius: 2,
//                 width: 34,
//                 height: 34,
//               }}
//             >
//               {theme === "dark" ? "☀️" : "🌙"}
//             </IconButton>
//           </Tooltip>
//         </Stack>
//       </Stack>

//       {/* ── KPI cards ── */}
//       <SectionLabel COLORS={COLORS}>Overview metrics</SectionLabel>
//       <Grid container spacing={1.5} mb={2.5}>
//         {kpiCards.map((k) => (
//           <Grid item xs={6} sm={4} md={2} key={k.label}>
//             <MetricCard {...k} accentColor={k.color} COLORS={COLORS} />
//           </Grid>
//         ))}
//       </Grid>

//       {/* ── Platform quick stats ── */}
//       <SectionLabel COLORS={COLORS}>Platform summary</SectionLabel>
//       <Grid container spacing={1.5} mb={2.5}>
//         {platformStats.map((s) => (
//           <Grid item xs={6} sm={3} key={s.label}>
//             <Card
//               elevation={0}
//               sx={{
//                 background: COLORS.cardBg,
//                 border: `1px solid ${COLORS.border}`,
//                 borderRadius: 3,
//               }}
//             >
//               <CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
//                 <Stack direction="row" alignItems="center" gap={1.2}>
//                   <Avatar
//                     sx={{ width: 32, height: 32, borderRadius: 2, background: `${s.color}18` }}
//                   >
//                     <s.icon sx={{ fontSize: 15, color: s.color }} />
//                   </Avatar>
//                   <Box>
//                     <Typography sx={{ fontSize: 20, fontWeight: 700, color: COLORS.text, lineHeight: 1 }}>
//                       {s.value}
//                     </Typography>
//                     <Typography sx={{ fontSize: 10, color: COLORS.card_txt_color }}>
//                       {s.label}
//                     </Typography>
//                   </Box>
//                 </Stack>
//               </CardContent>
//             </Card>
//           </Grid>
//         ))}
//       </Grid>

//       {/* ── Middle row ── */}
//       <Grid container spacing={1.5} mb={2.5}>
//         {/* Geographic Coverage */}
//         <Grid item xs={12} md={5}>
//           <Card
//             elevation={0}
//             sx={{ background: COLORS.cardBg, border: `1px solid ${COLORS.border}`, borderRadius: 3, height: "100%" }}
//           >
//             <CardContent sx={{ p: 2.5 }}>
//               <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
//                 <Typography sx={{ fontSize: 13, fontWeight: 600, color: COLORS.text }}>
//                   Geographic Coverage
//                 </Typography>
//                 <Chip
//                   label={`${coverageScore}% health`}
//                   size="small"
//                   sx={{
//                     fontSize: 10,
//                     fontWeight: 600,
//                     background: `${accent}18`,
//                     color: accent,
//                     height: 20,
//                   }}
//                 />
//               </Stack>

//               <Typography sx={{ fontSize: 11, fontWeight: 600, color: COLORS.card_txt_color, mb: 1 }}>
//                 States
//               </Typography>
//               <GeoRow label="States" active={d.states.active} total={d.states.total} color={accent} />

//               <Typography sx={{ fontSize: 11, fontWeight: 600, color: COLORS.card_txt_color, mb: 1, mt: 1.5 }}>
//                 Districts
//               </Typography>
//               <GeoRow label="Districts" active={d.districts.active} total={d.districts.total} color={purple} />

//               <Typography sx={{ fontSize: 11, fontWeight: 600, color: COLORS.card_txt_color, mb: 1, mt: 1.5 }}>
//                 Cities
//               </Typography>
//               <GeoRow label="Cities" active={d.cities.active} total={d.cities.total} color={teal} />

//               <Divider sx={{ my: 2, borderColor: COLORS.border }} />

//               <Typography sx={{ fontSize: 11, fontWeight: 600, color: COLORS.card_txt_color, mb: 1 }}>
//                 Active states
//               </Typography>
//               <Stack direction="row" gap={0.7} flexWrap="wrap" mb={1.5}>
//                 {d.states.active_list.map((s) => (
//                   <Chip
//                     key={s}
//                     icon={<Map sx={{ fontSize: "12px !important" }} />}
//                     label={s}
//                     size="small"
//                     sx={{ fontSize: 10, height: 22, background: COLORS.card_chip_bg, color: COLORS.text }}
//                   />
//                 ))}
//               </Stack>

//               <Typography sx={{ fontSize: 11, fontWeight: 600, color: COLORS.card_txt_color, mb: 1 }}>
//                 Active cities
//               </Typography>
//               <Stack direction="row" gap={0.7} flexWrap="wrap">
//                 {d.cities.active_list.map((c) => (
//                   <Chip
//                     key={c}
//                     icon={<LocationCityOutlined sx={{ fontSize: "12px !important" }} />}
//                     label={c}
//                     size="small"
//                     sx={{
//                       fontSize: 10,
//                       height: 22,
//                       background: `${accent}12`,
//                       color: accent,
//                       fontWeight: 600,
//                     }}
//                   />
//                 ))}
//               </Stack>
//             </CardContent>
//           </Card>
//         </Grid>

//         {/* Active Jobs by Skills */}
//         <Grid item xs={12} md={4}>
//           <Card
//             elevation={0}
//             sx={{ background: COLORS.cardBg, border: `1px solid ${COLORS.border}`, borderRadius: 3, height: "100%" }}
//           >
//             <CardContent sx={{ p: 2.5 }}>
//               <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
//                 <Typography sx={{ fontSize: 13, fontWeight: 600, color: COLORS.text }}>
//                   Jobs by Skill
//                 </Typography>
//                 <Chip
//                   label={`${d.total_active_skills} skills`}
//                   size="small"
//                   sx={{
//                     fontSize: 10,
//                     fontWeight: 600,
//                     background: `${purple}18`,
//                     color: purple,
//                     height: 20,
//                   }}
//                 />
//               </Stack>
//               {d.Active_Jobs_by_Skills.map((s) => (
//                 <SkillRow key={s.skill} skill={s.skill} count={s.job_count} max={maxSkillCount} COLORS={COLORS} />
//               ))}

//               <Divider sx={{ my: 2, borderColor: COLORS.border }} />

//               <Typography sx={{ fontSize: 11, fontWeight: 600, color: COLORS.card_txt_color, mb: 1 }}>
//                 Interview pipeline
//               </Typography>
//               {[
//                 { label: "Scheduled", val: m.interviews_scheduled, color: purple },
//                 { label: "Completed", val: m.interviews_completed, color: teal },
//                 { label: "Active status", val: d.interview_status.Active, color: green },
//               ].map((r) => (
//                 <Stack
//                   key={r.label}
//                   direction="row"
//                   justifyContent="space-between"
//                   alignItems="center"
//                   sx={{ py: 0.8, borderBottom: `0.5px solid ${COLORS.border}` }}
//                 >
//                   <Typography sx={{ fontSize: 12, color: COLORS.card_txt_color }}>{r.label}</Typography>
//                   <Chip
//                     label={r.val}
//                     size="small"
//                     sx={{
//                       height: 20,
//                       fontSize: 11,
//                       fontWeight: 700,
//                       background: `${r.color}18`,
//                       color: r.color,
//                     }}
//                   />
//                 </Stack>
//               ))}
//             </CardContent>
//           </Card>
//         </Grid>

//         {/* Workforce breakdown */}
//         <Grid item xs={12} md={3}>
//           <Card
//             elevation={0}
//             sx={{ background: COLORS.cardBg, border: `1px solid ${COLORS.border}`, borderRadius: 3, height: "100%" }}
//           >
//             <CardContent sx={{ p: 2.5 }}>
//               <Typography sx={{ fontSize: 13, fontWeight: 600, color: COLORS.text, mb: 2 }}>
//                 Workforce
//               </Typography>
//               {[
//                 { label: "Total Staff", val: m.total_staff, color: accent, icon: PeopleAlt },
//                 { label: "Internal Interviewers", val: m.total_interviewers, color: purple, icon: RecordVoiceOver },
//                 { label: "3rd-Party Interviewers", val: m.third_party_interviewers, color: teal, icon: GroupsOutlined },
//                 { label: "Admin Users", val: d.user_distribution.Admin, color: green, icon: ManageAccountsOutlined },
//                 { label: "Other Users", val: d.user_distribution.null || 0, color: amber, icon: PeopleAlt },
//               ].map((w) => (
//                 <Stack
//                   key={w.label}
//                   direction="row"
//                   justifyContent="space-between"
//                   alignItems="center"
//                   sx={{ py: 1, borderBottom: `0.5px solid ${COLORS.border}` }}
//                 >
//                   <Stack direction="row" alignItems="center" gap={1}>
//                     <Avatar sx={{ width: 24, height: 24, borderRadius: 1, background: `${w.color}18` }}>
//                       <w.icon sx={{ fontSize: 12, color: w.color }} />
//                     </Avatar>
//                     <Typography sx={{ fontSize: 11, color: COLORS.card_txt_color }}>{w.label}</Typography>
//                   </Stack>
//                   <Typography sx={{ fontSize: 14, fontWeight: 700, color: COLORS.text }}>{w.val}</Typography>
//                 </Stack>
//               ))}

//               <Divider sx={{ my: 2, borderColor: COLORS.border }} />

//               <Paper
//                 elevation={0}
//                 sx={{
//                   p: 1.5,
//                   borderRadius: 2,
//                   background: `${accent}10`,
//                   border: `1px solid ${accent}22`,
//                 }}
//               >
//                 <Typography sx={{ fontSize: 11, fontWeight: 600, color: accent, mb: 0.4 }}>
//                   Platform health
//                 </Typography>
//                 <Typography sx={{ fontSize: 11, color: COLORS.card_txt_color, lineHeight: 1.5 }}>
//                   All scheduled interviews completed. No pending backlogs detected.
//                 </Typography>
//               </Paper>
//             </CardContent>
//           </Card>
//         </Grid>
//       </Grid>

//       {/* ── Bottom row: Districts ── */}
//       <SectionLabel COLORS={COLORS}>Active districts</SectionLabel>
//       <Grid container spacing={1} mb={1}>
//         {d.districts.active_list.map((dist, i) => {
//           const colors = [accent, purple, teal, green, amber, "#dc2626"];
//           return (
//             <Grid item key={dist}>
//               <Chip
//                 icon={<ApartmentOutlined sx={{ fontSize: "13px !important", color: `${colors[i % colors.length]} !important` }} />}
//                 label={dist}
//                 variant="outlined"
//                 sx={{
//                   fontSize: 11,
//                   height: 28,
//                   borderColor: `${colors[i % colors.length]}44`,
//                   color: COLORS.text,
//                   background: `${colors[i % colors.length]}08`,
//                   fontWeight: 500,
//                   "& .MuiChip-icon": { color: colors[i % colors.length] },
//                 }}
//               />
//             </Grid>
//           );
//         })}
//         <Grid item>
//           <Chip
//             label={`+${d.districts.inactive} inactive`}
//             size="small"
//             sx={{
//               fontSize: 10,
//               height: 28,
//               background: "rgba(217,119,6,0.1)",
//               color: amber,
//               fontWeight: 600,
//             }}
//           />
//         </Grid>
//       </Grid>
//     </Box>
//   );
// }






















































import React, { useState, useEffect } from "react";
import {
  Box, Grid, Card, CardContent, Typography, Chip, LinearProgress,
  Divider, IconButton, Tooltip, Avatar, Stack, Paper, Skeleton, Alert, Button,
} from "@mui/material";
import {
  PeopleAlt, Business, WorkOutline, EventNote, CheckCircleOutline,
  RecordVoiceOver, Map, ApartmentOutlined, LocationCityOutlined,
  AutoAwesome, TrendingUp, ManageAccountsOutlined, GroupsOutlined,
  VerifiedOutlined, RefreshOutlined, ErrorOutlineOutlined,
} from "@mui/icons-material";
import { useThemeMode } from "../../Themes/ThemeContextTemp";
import createInstance from "../../../api/axiosinstance";

// ─── Safe empty structure — all zeros/empty arrays ────────────────────────────
const EMPTY_DATA = {
  metrics: {
    total_organizations: 0, active_organizations: 0,
    total_users: 0, active_users: 0,
    total_staff: 0, total_interviewers: 0, third_party_interviewers: 0,
    jobs_created: 0, interviews_scheduled: 0, interviews_completed: 0,
  },
  states:    { total: 0, active: 0, inactive: 0, active_list: [] },
  districts: { total: 0, active: 0, inactive: 0, active_list: [] },
  cities:    { total: 0, active: 0, inactive: 0, active_list: [] },
  user_distribution: { Admin: 0, null: 0 },
  interview_status:  { Active: 0 },
  Active_Jobs_by_Skills: [],
  total_active_users: 0, total_active_skills: 0,
  total_active_roles: 0, total_active_org: 0,
};

// ─── Map raw API → UI shape with ?? fallbacks on every field ─────────────────
const mapDashboardData = (api = {}) => ({
  metrics: {
    total_organizations:      api.metrics?.total_organizations      ?? 0,
    active_organizations:     api.metrics?.active_organizations     ?? 0,
    total_users:              api.metrics?.total_users              ?? 0,
    active_users:             api.metrics?.active_users             ?? 0,
    total_staff:              api.metrics?.total_staff              ?? 0,
    total_interviewers:       api.metrics?.total_interviewers       ?? 0,
    third_party_interviewers: api.metrics?.third_party_interviewers ?? 0,
    jobs_created:             api.metrics?.jobs_created             ?? 0,
    interviews_scheduled:     api.metrics?.interviews_scheduled     ?? 0,
    interviews_completed:     api.metrics?.interviews_completed     ?? 0,
  },
  states: {
    total: api.states?.total ?? 0, active: api.states?.active ?? 0,
    inactive: api.states?.inactive ?? 0, active_list: api.states?.active_list ?? [],
  },
  districts: {
    total: api.districts?.total ?? 0, active: api.districts?.active ?? 0,
    inactive: api.districts?.inactive ?? 0, active_list: api.districts?.active_list ?? [],
  },
  cities: {
    total: api.cities?.total ?? 0, active: api.cities?.active ?? 0,
    inactive: api.cities?.inactive ?? 0, active_list: api.cities?.active_list ?? [],
  },
  user_distribution:     api.user_distribution     ?? { Admin: 0, null: 0 },
  interview_status:      api.interview_status      ?? { Active: 0 },
  Active_Jobs_by_Skills: api.Active_Jobs_by_Skills ?? api.jobs_by_skills ?? [],
  total_active_users:    api.total_active_users    ?? 0,
  total_active_skills:   api.total_active_skills   ?? 0,
  total_active_roles:    api.total_active_roles    ?? 0,
  total_active_org:      api.total_active_org      ?? 0,
});

// ─── Safe coverage score (no divide-by-zero) ─────────────────────────────────
const safeCoverage = (d) => {
  const parts = [
    d.states.total    > 0 ? d.states.active    / d.states.total    : null,
    d.districts.total > 0 ? d.districts.active / d.districts.total : null,
    d.cities.total    > 0 ? d.cities.active    / d.cities.total    : null,
  ].filter((v) => v !== null);
  return parts.length > 0
    ? Math.round((parts.reduce((a, b) => a + b, 0) / parts.length) * 100)
    : 0;
};

// ─── Skeleton card ────────────────────────────────────────────────────────────
function MetricCardSkeleton({ COLORS }) {
  return (
    <Card elevation={0} sx={{ background: COLORS.cardBg, border: `1px solid ${COLORS.border}`, borderRadius: 3 }}>
      <Box sx={{ height: 3, background: COLORS.border, borderRadius: "12px 12px 0 0" }} />
      <CardContent sx={{ p: 2.2 }}>
        <Skeleton width="60%" height={14} sx={{ mb: 1 }} />
        <Skeleton width="40%" height={36} sx={{ mb: 0.5 }} />
        <Skeleton width="80%" height={12} />
      </CardContent>
    </Card>
  );
}

// ─── KPI card ─────────────────────────────────────────────────────────────────
function MetricCard({ label, value, sub, icon: Icon, accentColor, COLORS }) {
  return (
    <Card elevation={0} sx={{
      background: COLORS.cardBg, border: `1px solid ${COLORS.border}`,
      borderRadius: 3, height: "100%", overflow: "hidden",
      transition: "transform 0.18s, box-shadow 0.18s",
      "&:hover": { transform: "translateY(-2px)", boxShadow: `0 6px 24px ${accentColor}22` },
    }}>
      <Box sx={{ height: 3, background: accentColor, borderRadius: "12px 12px 0 0" }} />
      <CardContent sx={{ p: 2.2 }}>
        <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
          <Box>
            <Typography sx={{ fontSize: 11, color: COLORS.card_txt_color, mb: 0.6, letterSpacing: 0.3 }}>{label}</Typography>
            <Typography sx={{ fontSize: 28, fontWeight: 700, color: COLORS.text, lineHeight: 1 }}>{value}</Typography>
            {sub && <Typography sx={{ fontSize: 11, color: COLORS.card_txt_color, mt: 0.8 }}>{sub}</Typography>}
          </Box>
          <Avatar sx={{ width: 38, height: 38, borderRadius: 2, background: `${accentColor}18` }}>
            <Icon sx={{ fontSize: 18, color: accentColor }} />
          </Avatar>
        </Stack>
      </CardContent>
    </Card>
  );
}

// ─── Geo progress row ─────────────────────────────────────────────────────────
function GeoRow({ label, active, total, color }) {
  const pct = total > 0 ? Math.round((active / total) * 100) : 0;
  return (
    <Box sx={{ mb: 1.2 }}>
      <Stack direction="row" justifyContent="space-between" mb={0.4}>
        <Typography sx={{ fontSize: 12, fontWeight: 500 }}>{label}</Typography>
        <Typography sx={{ fontSize: 11, opacity: 0.6 }}>{active}/{total}</Typography>
      </Stack>
      <LinearProgress variant="determinate" value={pct} sx={{
        height: 6, borderRadius: 4,
        backgroundColor: "rgba(128,128,128,0.12)",
        "& .MuiLinearProgress-bar": { background: color, borderRadius: 4 },
      }} />
    </Box>
  );
}

// ─── Skill bar row ────────────────────────────────────────────────────────────
function SkillRow({ skill, count, max, index, COLORS }) {
  const pct = max > 0 ? Math.round((count / max) * 100) : 0;
  const chipColors = ["rgb(37,99,235)", "#7c3aed", "#0d9488"];
  const c = chipColors[index % chipColors.length];
  return (
    <Box sx={{ mb: 1.6 }}>
      <Stack direction="row" justifyContent="space-between" mb={0.5}>
        <Typography sx={{ fontSize: 12, fontWeight: 500, color: COLORS.text }}>{skill}</Typography>
        <Chip label={`${count} job${count !== 1 ? "s" : ""}`} size="small"
          sx={{ height: 18, fontSize: 10, fontWeight: 600, background: `${c}18`, color: c }} />
      </Stack>
      <LinearProgress variant="determinate" value={pct} sx={{
        height: 8, borderRadius: 4,
        backgroundColor: "rgba(128,128,128,0.12)",
        "& .MuiLinearProgress-bar": {
          background: "linear-gradient(90deg, rgb(37,99,235), #7c3aed)", borderRadius: 4,
        },
      }} />
    </Box>
  );
}

// ─── Section label ────────────────────────────────────────────────────────────
function SectionLabel({ children, COLORS }) {
  return (
    <Typography sx={{
      fontSize: 10, fontWeight: 700, letterSpacing: 1,
      color: COLORS.card_txt_color, textTransform: "uppercase", mb: 1.2, mt: 0.5,
    }}>{children}</Typography>
  );
}

// ─── Main Dashboard ───────────────────────────────────────────────────────────
export default function StrategicHireDashboard() {
  const { COLORS, theme, toggleTheme } = useThemeMode();
  const aiDisha = createInstance("DISHA");

  const [data,    setData]    = useState(null);   // null = not yet fetched
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState(null);

  const fetchDashboard = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await aiDisha.get("/Admin_Dashboard_values/");
      setData(mapDashboardData(response.data));
    } catch (err) {
      console.error("Dashboard fetch error:", err);
      setError("Unable to load dashboard data. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchDashboard(); }, []);

  // Use live data when available; fall back to all-zeros skeleton data while loading
  const d = data ?? EMPTY_DATA;
  const m = d.metrics;

  const accent = theme === "dark" ? "#e6b450" : "rgb(37,99,235)";
  const purple = "#7c3aed";
  const teal   = "#0d9488";
  const green  = "#16a34a";
  const amber  = "#d97706";

  const coverageScore = safeCoverage(d);
  const maxSkillCount = d.Active_Jobs_by_Skills.length > 0
    ? Math.max(...d.Active_Jobs_by_Skills.map((s) => s.job_count))
    : 1;

  const kpiCards = [
    { label: "Total Users",   value: m.total_users,      sub: `${m.active_users} active · ${m.total_users - m.active_users} inactive`,                              icon: PeopleAlt,          color: accent  },
    { label: "Organizations", value: m.total_organizations, sub: `${m.active_organizations} active · ${m.total_organizations - m.active_organizations} inactive`,  icon: Business,           color: green   },
    { label: "Jobs Created",  value: m.jobs_created,     sub: "Open positions",                                                                                     icon: WorkOutline,        color: amber   },
    { label: "Scheduled",     value: m.interviews_scheduled, sub: `${d.interview_status?.Active ?? 0} currently active`,                                           icon: EventNote,          color: purple  },
    { label: "Completed",     value: m.interviews_completed, sub: "Completion rate",                                                                                icon: CheckCircleOutline, color: teal    },
    { label: "Interviewers",  value: m.total_interviewers + m.third_party_interviewers, sub: `${m.total_interviewers} staff · ${m.third_party_interviewers} 3rd-party`, icon: RecordVoiceOver, color: accent },
  ];

  const platformStats = [
    { label: "Active Users",  value: d.total_active_users,  icon: GroupsOutlined,         color: accent  },
    { label: "Active Skills", value: d.total_active_skills, icon: AutoAwesome,            color: purple  },
    { label: "Active Roles",  value: d.total_active_roles,  icon: ManageAccountsOutlined, color: teal    },
    { label: "Active Orgs",   value: d.total_active_org,    icon: VerifiedOutlined,       color: green   },
  ];

  const workforceRows = [
    { label: "Total Staff",            val: m.total_staff,                          color: accent,  icon: PeopleAlt              },
    { label: "Internal Interviewers",  val: m.total_interviewers,                   color: purple,  icon: RecordVoiceOver        },
    { label: "3rd-Party Interviewers", val: m.third_party_interviewers,             color: teal,    icon: GroupsOutlined         },
    { label: "Admin Users",            val: d.user_distribution?.Admin ?? 0,        color: green,   icon: ManageAccountsOutlined },
    { label: "Other Users",            val: d.user_distribution?.null  ?? 0,        color: amber,   icon: PeopleAlt              },
  ];

  const districtColors = [accent, purple, teal, green, amber, "#dc2626"];

  // ── Full-page error (first load failed, no previous data) ────────────────────
  if (error && !data) {
    return (
      <Box sx={{ background: COLORS.background, minHeight: "100vh", p: 3, display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Paper elevation={0} sx={{ p: 4, borderRadius: 3, background: COLORS.cardBg, border: `1px solid ${COLORS.border}`, textAlign: "center", maxWidth: 420 }}>
          <Avatar sx={{ width: 56, height: 56, borderRadius: 2, background: "rgba(220,38,38,0.1)", mx: "auto", mb: 2 }}>
            <ErrorOutlineOutlined sx={{ fontSize: 28, color: "#dc2626" }} />
          </Avatar>
          <Typography sx={{ fontSize: 15, fontWeight: 600, color: COLORS.text, mb: 1 }}>Failed to load dashboard</Typography>
          <Typography sx={{ fontSize: 12, color: COLORS.card_txt_color, mb: 2.5, lineHeight: 1.6 }}>{error}</Typography>
          <Button variant="outlined" startIcon={<RefreshOutlined />} onClick={fetchDashboard}
            sx={{ borderColor: accent, color: accent, borderRadius: 2, textTransform: "none", fontWeight: 600 }}>
            Retry
          </Button>
        </Paper>
      </Box>
    );
  }

  return (
    <Box sx={{ background: COLORS.background, minHeight: "100vh", p: { xs: 2, md: 3 } }}>

      {/* ── Soft banner when refresh fails but stale data is available ── */}
      {error && data && (
        <Alert severity="warning" action={<Button size="small" onClick={fetchDashboard}>Retry</Button>}
          sx={{ mb: 2, borderRadius: 2, fontSize: 12 }}>
          Could not refresh data — showing last loaded values.
        </Alert>
      )}

      {/* ── Top bar ── */}
      <Stack direction="row" alignItems="center" justifyContent="space-between" mb={3}>
        <Stack direction="row" alignItems="center" gap={1.5}>
          <Avatar sx={{ width: 40, height: 40, borderRadius: 2, background: accent }}>
            <TrendingUp sx={{ fontSize: 20, color: "white" }} />
          </Avatar>
          <Box>
            <Typography sx={{ fontSize: 16, fontWeight: 700, color: COLORS.text, lineHeight: 1.2 }}>Strategic Hire</Typography>
            <Typography sx={{ fontSize: 11, color: COLORS.card_txt_color }}>Admin Dashboard</Typography>
          </Box>
        </Stack>
        <Stack direction="row" alignItems="center" gap={1}>
          <Chip label={loading ? "Loading…" : "● Live"} size="small" sx={{
            fontSize: 11, fontWeight: 600, height: 24,
            background: loading ? "rgba(107,114,128,0.12)" : "rgba(22,163,74,0.12)",
            color: loading ? "#6b7280" : "#16a34a",
          }} />
          <Tooltip title="Refresh">
            <span>
              <IconButton onClick={fetchDashboard} disabled={loading} size="small" sx={{
                border: `1px solid ${COLORS.border}`, background: COLORS.cardBg,
                color: COLORS.text, borderRadius: 2, width: 34, height: 34,
              }}>
                <RefreshOutlined sx={{ fontSize: 16, ...(loading && { animation: "spin 1s linear infinite" }) }} />
              </IconButton>
            </span>
          </Tooltip>
          <Tooltip title={`Switch to ${theme === "dark" ? "light" : "dark"} theme`}>
            <IconButton onClick={toggleTheme} size="small" sx={{
              border: `1px solid ${COLORS.border}`, background: COLORS.cardBg,
              color: COLORS.text, borderRadius: 2, width: 34, height: 34,
            }}>
              {theme === "dark" ? "☀️" : "🌙"}
            </IconButton>
          </Tooltip>
        </Stack>
      </Stack>

      {/* ── KPI cards ── */}
      <SectionLabel COLORS={COLORS}>Overview metrics</SectionLabel>
      <Grid container spacing={1.5} mb={2.5}>
        {loading
          ? Array.from({ length: 6 }).map((_, i) => (
              <Grid item xs={6} sm={4} md={2} key={i}><MetricCardSkeleton COLORS={COLORS} /></Grid>
            ))
          : kpiCards.map((k) => (
              <Grid item xs={6} sm={4} md={2} key={k.label}>
                <MetricCard {...k} accentColor={k.color} COLORS={COLORS} />
              </Grid>
            ))
        }
      </Grid>

      {/* ── Platform summary ── */}
      <SectionLabel COLORS={COLORS}>Platform summary</SectionLabel>
      <Grid container spacing={1.5} mb={2.5}>
        {platformStats.map((s) => (
          <Grid item xs={6} sm={3} key={s.label}>
            <Card elevation={0} sx={{ background: COLORS.cardBg, border: `1px solid ${COLORS.border}`, borderRadius: 3 }}>
              <CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
                {loading ? (
                  <Stack direction="row" alignItems="center" gap={1.2}>
                    <Skeleton variant="rounded" width={32} height={32} />
                    <Box sx={{ flex: 1 }}><Skeleton width="50%" height={28} /><Skeleton width="80%" height={12} /></Box>
                  </Stack>
                ) : (
                  <Stack direction="row" alignItems="center" gap={1.2}>
                    <Avatar sx={{ width: 32, height: 32, borderRadius: 2, background: `${s.color}18` }}>
                      <s.icon sx={{ fontSize: 15, color: s.color }} />
                    </Avatar>
                    <Box>
                      <Typography sx={{ fontSize: 20, fontWeight: 700, color: COLORS.text, lineHeight: 1 }}>{s.value}</Typography>
                      <Typography sx={{ fontSize: 10, color: COLORS.card_txt_color }}>{s.label}</Typography>
                    </Box>
                  </Stack>
                )}
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* ── Middle row ── */}
      <Grid container spacing={1.5} mb={2.5}>

        {/* Geographic Coverage */}
        <Grid item xs={12} md={5}>
          <Card elevation={0} sx={{ background: COLORS.cardBg, border: `1px solid ${COLORS.border}`, borderRadius: 3, height: "100%" }}>
            <CardContent sx={{ p: 2.5 }}>
              <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
                <Typography sx={{ fontSize: 13, fontWeight: 600, color: COLORS.text }}>Geographic Coverage</Typography>
                <Chip label={`${coverageScore}% health`} size="small"
                  sx={{ fontSize: 10, fontWeight: 600, background: `${accent}18`, color: accent, height: 20 }} />
              </Stack>

              {loading ? (
                [1,2,3].map((i) => (
                  <Box key={i} mb={1.5}><Skeleton height={12} width="40%" sx={{ mb: 0.5 }} /><Skeleton height={8} /></Box>
                ))
              ) : (
                <>
                  <Typography sx={{ fontSize: 11, fontWeight: 600, color: COLORS.card_txt_color, mb: 1 }}>States</Typography>
                  <GeoRow label="States" active={d.states.active} total={d.states.total} color={accent} />
                  <Typography sx={{ fontSize: 11, fontWeight: 600, color: COLORS.card_txt_color, mb: 1, mt: 1.5 }}>Districts</Typography>
                  <GeoRow label="Districts" active={d.districts.active} total={d.districts.total} color={purple} />
                  <Typography sx={{ fontSize: 11, fontWeight: 600, color: COLORS.card_txt_color, mb: 1, mt: 1.5 }}>Cities</Typography>
                  <GeoRow label="Cities" active={d.cities.active} total={d.cities.total} color={teal} />
                </>
              )}

              <Divider sx={{ my: 2, borderColor: COLORS.border }} />

              <Typography sx={{ fontSize: 11, fontWeight: 600, color: COLORS.card_txt_color, mb: 1 }}>Active states</Typography>
              <Stack direction="row" gap={0.7} flexWrap="wrap" mb={1.5}>
                {loading
                  ? [80,60,90].map((w, i) => <Skeleton key={i} variant="rounded" width={w} height={22} sx={{ borderRadius: 2 }} />)
                  : d.states.active_list.length > 0
                    ? d.states.active_list.map((s) => (
                        <Chip key={s} icon={<Map sx={{ fontSize: "12px !important" }} />} label={s} size="small"
                          sx={{ fontSize: 10, height: 22, background: COLORS.card_chip_bg, color: COLORS.text }} />
                      ))
                    : <Typography sx={{ fontSize: 11, color: COLORS.card_txt_color }}>No active states</Typography>
                }
              </Stack>

              <Typography sx={{ fontSize: 11, fontWeight: 600, color: COLORS.card_txt_color, mb: 1 }}>Active cities</Typography>
              <Stack direction="row" gap={0.7} flexWrap="wrap">
                {loading
                  ? [70,65,75].map((w, i) => <Skeleton key={i} variant="rounded" width={w} height={22} sx={{ borderRadius: 2 }} />)
                  : d.cities.active_list.length > 0
                    ? d.cities.active_list.map((c) => (
                        <Chip key={c} icon={<LocationCityOutlined sx={{ fontSize: "12px !important" }} />} label={c} size="small"
                          sx={{ fontSize: 10, height: 22, background: `${accent}12`, color: accent, fontWeight: 600 }} />
                      ))
                    : <Typography sx={{ fontSize: 11, color: COLORS.card_txt_color }}>No active cities</Typography>
                }
              </Stack>
            </CardContent>
          </Card>
        </Grid>

        {/* Jobs by Skill */}
        <Grid item xs={12} md={4}>
          <Card elevation={0} sx={{ background: COLORS.cardBg, border: `1px solid ${COLORS.border}`, borderRadius: 3, height: "100%" }}>
            <CardContent sx={{ p: 2.5 }}>
              <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
                <Typography sx={{ fontSize: 13, fontWeight: 600, color: COLORS.text }}>Jobs by Skill</Typography>
                <Chip label={`${d.total_active_skills} skills`} size="small"
                  sx={{ fontSize: 10, fontWeight: 600, background: `${purple}18`, color: purple, height: 20 }} />
              </Stack>

              {loading
                ? [1,2,3].map((i) => (
                    <Box key={i} mb={1.8}><Skeleton width="60%" height={14} sx={{ mb: 0.5 }} /><Skeleton height={10} /></Box>
                  ))
                : d.Active_Jobs_by_Skills.length > 0
                  ? d.Active_Jobs_by_Skills.map((s, i) => (
                      <SkillRow key={s.skill} skill={s.skill} count={s.job_count} max={maxSkillCount} index={i} COLORS={COLORS} />
                    ))
                  : <Typography sx={{ fontSize: 12, color: COLORS.card_txt_color, py: 1 }}>No active skill data</Typography>
              }

              <Divider sx={{ my: 2, borderColor: COLORS.border }} />
              <Typography sx={{ fontSize: 11, fontWeight: 600, color: COLORS.card_txt_color, mb: 1 }}>Interview pipeline</Typography>
              {[
                { label: "Scheduled",    val: m.interviews_scheduled,       color: purple },
                { label: "Completed",    val: m.interviews_completed,       color: teal   },
                { label: "Active status",val: d.interview_status?.Active ?? 0, color: green },
              ].map((r) => (
                <Stack key={r.label} direction="row" justifyContent="space-between" alignItems="center"
                  sx={{ py: 0.8, borderBottom: `0.5px solid ${COLORS.border}` }}>
                  <Typography sx={{ fontSize: 12, color: COLORS.card_txt_color }}>{r.label}</Typography>
                  {loading
                    ? <Skeleton width={30} height={20} variant="rounded" />
                    : <Chip label={r.val} size="small"
                        sx={{ height: 20, fontSize: 11, fontWeight: 700, background: `${r.color}18`, color: r.color }} />
                  }
                </Stack>
              ))}
            </CardContent>
          </Card>
        </Grid>

        {/* Workforce */}
        <Grid item xs={12} md={3}>
          <Card elevation={0} sx={{ background: COLORS.cardBg, border: `1px solid ${COLORS.border}`, borderRadius: 3, height: "100%" }}>
            <CardContent sx={{ p: 2.5 }}>
              <Typography sx={{ fontSize: 13, fontWeight: 600, color: COLORS.text, mb: 2 }}>Workforce</Typography>
              {workforceRows.map((w) => (
                <Stack key={w.label} direction="row" justifyContent="space-between" alignItems="center"
                  sx={{ py: 1, borderBottom: `0.5px solid ${COLORS.border}` }}>
                  <Stack direction="row" alignItems="center" gap={1}>
                    <Avatar sx={{ width: 24, height: 24, borderRadius: 1, background: `${w.color}18` }}>
                      <w.icon sx={{ fontSize: 12, color: w.color }} />
                    </Avatar>
                    <Typography sx={{ fontSize: 11, color: COLORS.card_txt_color }}>{w.label}</Typography>
                  </Stack>
                  {loading
                    ? <Skeleton width={20} height={20} />
                    : <Typography sx={{ fontSize: 14, fontWeight: 700, color: COLORS.text }}>{w.val}</Typography>
                  }
                </Stack>
              ))}

              <Divider sx={{ my: 2, borderColor: COLORS.border }} />
              <Paper elevation={0} sx={{ p: 1.5, borderRadius: 2, background: `${accent}10`, border: `1px solid ${accent}22` }}>
                <Typography sx={{ fontSize: 11, fontWeight: 600, color: accent, mb: 0.4 }}>Platform health</Typography>
                <Typography sx={{ fontSize: 11, color: COLORS.card_txt_color, lineHeight: 1.5 }}>
                  {loading
                    ? "Checking status…"
                    : m.interviews_scheduled > 0 && m.interviews_scheduled === m.interviews_completed
                      ? "All scheduled interviews completed. No pending backlogs."
                      : m.interviews_scheduled > m.interviews_completed
                        ? `${m.interviews_scheduled - m.interviews_completed} interview(s) pending completion.`
                        : "No interview data available yet."
                  }
                </Typography>
              </Paper>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* ── Active districts ── */}
      <SectionLabel COLORS={COLORS}>Active districts</SectionLabel>
      <Grid container spacing={1} mb={1}>
        {loading
          ? [90,70,80,65,75,85].map((w, i) => (
              <Grid item key={i}><Skeleton variant="rounded" width={w} height={28} sx={{ borderRadius: 2 }} /></Grid>
            ))
          : d.districts.active_list.length > 0
            ? d.districts.active_list.map((dist, i) => {
                const c = districtColors[i % districtColors.length];
                return (
                  <Grid item key={dist}>
                    <Chip
                      icon={<ApartmentOutlined sx={{ fontSize: "13px !important", color: `${c} !important` }} />}
                      label={dist} variant="outlined"
                      sx={{
                        fontSize: 11, height: 28, fontWeight: 500,
                        borderColor: `${c}44`, color: COLORS.text, background: `${c}08`,
                        "& .MuiChip-icon": { color: c },
                      }}
                    />
                  </Grid>
                );
              })
            : (
              <Grid item>
                <Typography sx={{ fontSize: 12, color: COLORS.card_txt_color }}>No active districts</Typography>
              </Grid>
            )
        }
        {!loading && d.districts.inactive > 0 && (
          <Grid item>
            <Chip label={`+${d.districts.inactive} inactive`} size="small"
              sx={{ fontSize: 10, height: 28, background: "rgba(217,119,6,0.1)", color: amber, fontWeight: 600 }} />
          </Grid>
        )}
      </Grid>

      <style>{`@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }`}</style>
    </Box>
  );
}